import LanguageNav from './language-nav.ts';
import TableSet from './tableset.ts';
import FrequencyTable from './frequency-table.ts';


export {
    LanguageNav,
    TableSet,
    FrequencyTable,
};

